import { EventTypeEnum } from '../../../../../../../common/dist/angular/enums/event-type.enum';

export class TimelineEventModel {
  id: string;
  organizationId: string;
  eventType: EventTypeEnum;
  userName: string;
  createdAt: Date;
  eventText: string;
  lastModifiedText: string;
  titleText: string;
  payload: any;
}
